"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync } from "vue-property-decorator";
import i18n from "@/lang";
import UiDrawer from "@/components/drawer/UiDrawer.vue";
import UiForm from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { Debounce } from "vue-debounce-decorator";
import { DrawerComponent } from "@/components/core";
import DateFormat from "@/framework/timeformatter";
let TeamLogSearchForm = class extends DrawerComponent {
  constructor() {
    super(...arguments);
    this.selectOption = [
      {
        value: "auth_user",
        label: this.$t("teamLogs.table.event_auth_user")
      },
      {
        value: "user_delete_auto",
        label: this.$t("teamLogs.table.event_user_delete_auto")
      },
      {
        value: "vd_admin_user",
        label: this.$t("teamLogs.table.event_vd_admin_user")
      },
      {
        value: "user_delete",
        label: this.$t("teamLogs.table.event_user_delete")
      },
      {
        value: "user_add",
        label: this.$t("teamLogs.table.event_user_add")
      },
      {
        value: "user_edit_power",
        label: this.$t("teamLogs.table.event_user_edit_power")
      },
      {
        value: "auth_user_cancel",
        label: this.$t("teamLogs.table.event_auth_user_cancel")
      },
      {
        value: "vd_admin_user_cancel",
        label: this.$t("teamLogs.table.event_vd_admin_user_cancel")
      }
    ];
    this.pickerOptions = {
      shortcuts: [
        {
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              new Date(start.setMonth(start.getMonth() - 1)).setDate(1)
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ],
      disabledDate(time) {
        return time.getTime() > new Date(
          new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1
        ) || time.getTime() < new Date(new Date().setMonth(new Date().getMonth() - 6));
      }
    };
  }
  get $query() {
    return this._query;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  static create(query) {
    const _vue = new this({
      i18n,
      el: document.createElement("div"),
      propsData: {
        query
      }
    });
    return _vue;
  }
  search() {
    return __async(this, null, function* () {
      try {
        let searchParams = {
          params: ""
        };
        if (!this.isEmptyString(this.$query.operatorName)) {
          searchParams.params += `operatorName=like='${this.$query.operatorName}';`;
        }
        if (this.$query.createdTime.length === 2) {
          let mintime = Date.parse(this.$query.createdTime[0]);
          let maxtime = Date.parse(this.$query.createdTime[1]);
          searchParams.params += `createdTime=between=(${DateFormat.ToSecond(mintime)},${DateFormat.ToSecond(maxtime)});`;
        }
        if (!this.isEmptyString(this.$query.eventType)) {
          searchParams.params += `eventType==${this.$query.eventType};`;
        }
        if (!this.isEmptyString(this.$query.targetName)) {
          searchParams.params += `targetName=like='${this.$query.targetName}';`;
        }
        this.$emit("search", searchParams);
      } catch (error) {
      }
    });
  }
  isEmptyString(str) {
    if (str === "" || str === null || str === void 0) {
      return true;
    } else {
      return false;
    }
  }
  clearDrawer() {
    return __async(this, null, function* () {
      this.$query.operatorName = null;
      this.$query.createdTime = [];
      this.$query.eventType = null;
      this.$query.targetName = null;
      yield this.search();
    });
  }
};
__decorateClass([
  PropSync("query")
], TeamLogSearchForm.prototype, "_query", 2);
__decorateClass([
  Debounce(800)
], TeamLogSearchForm.prototype, "search", 1);
TeamLogSearchForm = __decorateClass([
  Component({
    components: {
      UiDrawer,
      UiForm,
      UiSubmit
    }
  })
], TeamLogSearchForm);
export {
  TeamLogSearchForm as default
};
